<template lang="pug">
  v-menu(
    v-if="shouldBeVisible"
    :class="filterMenuStyle()" 
    transition="slide-y-transition" 
    offset-y bottom right offset-x 
    v-model="showFilterMenu"
    @click="showFilterMenu" 
    :close-on-content-click="false")
    v-toolbar-title.liondesk(slot='activator' :class="filterMenuTitleStyle()")
      span {{ this.filterMenuLabel }}
      v-icon(right :class="filterMenuIconStyle()") {{ this.filterMenuIcon() }}
    v-list.filter-menu-list
      v-list-tile.mb-3.pt-2.filter-menu-item
        v-flex.filter-search
          v-text-field.filter-search-field(
            solo
            hide-details
            single-line
            clearable
            v-model="search"
            prepend-inner-icon='search'
            @keyup="shouldDisplayEveryone()"
            @click:clear="clearSearchField()"
          )
            template(slot="label")
              span.filter-search-label {{ label }}
      v-layout.ml-4.mb-3.check-everyone-container(v-if="displayEveryone" align-center, justify-start, row, fill-height)
        input.filter-item-checkbox(type='checkbox' class="checkbox" v-model="selectEveryone" @click="checkAllItems")
        p.px-3.mb-0.font-weight-bold.filter-types-everyone Everyone
      v-layout.filter-list-container(column)
        div(v-if="!isBroker()")
          p.px-3.mb-0.pt-2.font-weight-bold.filter-types-titles(v-if="searchedTeams.length") {{ setPrimaryLabelByUserType(this.userType) }}
          v-list-tile.ml-3(
            v-for='team in searchedTeams'
            :key='team.id'
          )
            v-layout(align-center, justify-start, row, fill-height)
              input.filter-item-checkbox(type='checkbox' class="checkbox" :value='team' :disabled="memberChecked ? true : false" v-model="selectedTeams")
              v-list-tile-title.ml-3.filter-item-text {{ team.name }}
        p.px-3.mt-2.mb-0.pt-2.font-weight-bold.filter-types-titles.filter-types-titles--users(v-if="searchedUsers.length") {{ setSecondaryLabelByUserType(this.userType) }}
        v-list-tile.ml-3(
          v-for='member in searchedUsers'
          :key='member.id'
        )
          v-layout(align-center, justify-start, row, fill-height)
            input.filter-item-checkbox(type="checkbox" class="checkbox" :value='member' :disabled="teamChecked ? true : false" v-model="selectedMembers")
            v-list-tile-title.ml-3.filter-item-text {{ member.name}}
      p.px-3.mb-2.no-results-msg(v-if="noResultsMsg") 
        | Your search returned 
        span.font-weight-bold
          | no results.
    v-layout.white(column)
      div.ma-0.warning-selections(v-if="shouldDisplayWarning") 
        p.ma-0.pt-2.warning-selections--msg {{ warningMsgText }}
      v-btn.ma-0.uncheck-selections.text-capitalize(@click='uncheckAll') Uncheck All
      v-layout.ma-0.apply-btn-container(align-center, justify-center)
        v-btn.primary.apply-btn(
          :disabled="isApplyBtnDisabled()"
          @click='applyFilter()'
        )
          | Apply
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { AGENT } from '@/Reporting/config/constants';

const DEFAULT_LABEL = 'FILTER REPORT';
const CUSTOM_SELECTION = 'Custom Selection';
const ALL_TEAMS = 'All Teams';
const ALL_USERS = 'All Users';
const TEAM = 'team';
const TEAMS = 'Teams';
const USERS = 'Users';
const BROKER = 'broker';
const BROKERS = 'Brokers';
const SUBACCOUNTS = 'Subaccounts';

export default {
  name: 'FilterReport',
  data() {
    return {
      shouldBeVisible: false,
      label: 'Search for a Team or User',
      showFilterMenu: false,
      filterMenuLabel: DEFAULT_LABEL,
      currentSelections: null,
      selectedMembers: [],
      selectedTeams: [],
      selectEveryone: [],
      displayEveryone: false,
      teamChecked: false,
      memberChecked: false,
      search: '',
      searchedTeams: [],
      searchedUsers: [],
      shouldDisplayWarning: false,
      warningMsgText: '',
      noResultsMsg: false,
    };
  },
  watch: {
    teams() {
      this.initialData();
    },
    showFilterMenu(val) {
      if (val) return;
      this.closeFilterMenu();
    },
    selectedTeams(val) {
      this.teamChecked = false;
      if (val.length) {
        this.teamChecked = true;
        this.disableSelections(TEAMS);
      }
      this.warningMsg();
    },
    selectedMembers(val) {
      this.memberChecked = false;
      if (val.length) {
        this.memberChecked = true;
        this.disableSelections(USERS);
      }
      this.warningMsg();
    },
    search(searchTerm) {
      this.performSearch(searchTerm);
    },
  },
  computed: {
    ...mapState('filterReport', ['teams', 'members', 'userType', 'error', 'isLoading']),
  },
  created() {
    this.getInfoForReportingFilter();
  },
  methods: {
    ...mapActions('filterReport', ['getInfoForReportingFilter']),
    isBroker() {
      return this.userType === BROKER;
    },
    shouldDisplayEveryone() {
      this.displayEveryone = !this.search.length;
    },
    clearSearchField() {
      this.displayEveryone = true;
    },
    performSearch(searchTerm) {
      if (!searchTerm) {
        this.searchedTeams = [...this.teams];
        this.searchedUsers = [...this.members];
        this.noResultsMsg = !this.searchedTeams.length && !this.searchedUsers.length;
        return;
      }

      const reduceFunc = (sectionList, selectedItems) => {
        return sectionList.reduce((acc, val) => {
          if (
            val.name.toLowerCase().indexOf(searchTerm.toLowerCase()) === -1 ||
            selectedItems.find(i => i.id === val.id)
          ) {
            return [...acc];
            }
          return [...acc, val];
        }, []);
      };

      const searchResultsTeams = reduceFunc(this.teams, this.selectedTeams);
      const searchResultsMembers = reduceFunc(this.members, this.selectedMembers);

      this.searchedTeams = [...this.selectedTeams, ...searchResultsTeams];
      this.searchedUsers = [...this.selectedMembers, ...searchResultsMembers];

      this.noResultsMsg = !this.searchedTeams.length && !this.searchedUsers.length;
    },
    applyFilter() {
      this.filterBtnLabel();
      this.displayEveryone = true;
      this.showFilterMenu = false;
      if (
        (this.selectedTeams.length && this.selectedMembers.length) ||
        (!this.selectedTeams.length && !this.selectedMembers.length)
      ) {
        this.$root.$emit('click:filter', []);
        this.$emit('click:filter', []);
        return;
      }
      if (this.selectedTeams.length) {
        this.$root.$emit('click:filter', this.selectedTeams);
        this.$emit('click:filter', this.selectedTeams);
        return;
      }
      this.$root.$emit('click:filter', this.selectedMembers);
      this.$emit('click:filter', this.selectedMembers);
    },
    initialData() {
      this.searchedTeams = [...this.teams];
      this.searchedUsers = [...this.members];
      if (this.searchedTeams || this.searchedUsers) {
        this.displayEveryone = true;
      }
      this.shouldBeVisible = !(this.members[0].target_type === AGENT);
    },
    setPrimaryLabelByUserType() {
      if (this.userType === BROKER) return BROKERS;
      return TEAMS;
    },
    setSecondaryLabelByUserType() {
      if (this.userType === BROKER) return SUBACCOUNTS;
      return USERS;
    },
    closeFilterMenu() {
      this.showFilterMenu = false;
      this.applyFilter();
    },
    checkAllItems() {
      if (this.selectEveryone.length) {
        this.uncheckAll();
        return;
      }
      this.selectedTeams = [...this.teams];
      this.selectedMembers = [...this.members];
      this.selectEveryone = [...this.selectedTeams, ...this.selectedMembers];
    },
    filterBtnLabel() {
      if (
        (this.selectedTeams.length && this.selectedMembers.length) ||
        (!this.selectedTeams.length && !this.selectedMembers.length)
      ) {
        this.filterMenuLabel = DEFAULT_LABEL;
        return;
      }
      if (this.selectedTeams.length === 1) {
        this.filterMenuLabel = this.selectedTeams[0].name;
        return;
      }
      if (
        (this.selectedTeams.length > 1 && this.selectedTeams.length !== this.teams.length) ||
        (this.selectedMembers.length > 1 && this.selectedMembers.length !== this.members.length)
      ) {
        this.filterMenuLabel = CUSTOM_SELECTION;
        return;
      }
      if (this.selectedTeams.length === this.teams.length) {
        this.filterMenuLabel = ALL_TEAMS;
        return;
      }
      if (this.selectedMembers.length === 1) {
        this.filterMenuLabel = this.selectedMembers[0].name;
        return;
      }
      if (this.selectedMembers.length === this.members.length) {
        this.filterMenuLabel = ALL_USERS;
        return;
      }
      this.filterMenuLabel = DEFAULT_LABEL;
    },
    uncheckAll() {
      this.selectedTeams = [];
      this.selectedMembers = [];
      this.selectEveryone = [];
      this.shouldDisplayWarning = false;
    },
    disableSelections(value) {
      if (this.selectEveryone.length) return;
      if (value === TEAMS) {
        this.selectedMembers = [];
        return;
      }
      this.selectedTeams = [];
    },
    warningMsg() {
      if (
        (!this.selectedTeams.length && !this.selectedMembers.length) ||
        (this.selectedTeams.length && this.selectedMembers.length) || isBroker()
      ) {
        this.shouldDisplayWarning = false;
        this.warningMsgText = '';
        return;
      }
      if (this.selectedTeams.length) {
        this.shouldDisplayWarning = true;
        this.warningMsgText = 'You have a team checked, click on uncheck all to select users.';
        return;
      }
      if (this.selectedMembers.length) {
        this.shouldDisplayWarning = true;
        this.warningMsgText = 'You have a user checked, click on uncheck all to select teams.';
        return;
      }
    },
    isApplyBtnDisabled() {
      return !this.selectedTeams.length && !this.selectedMembers.length;
    },
    filterMenuStyle() {
      return this.filterMenuLabel === DEFAULT_LABEL ? 'filter-menu-default' : '';
    },
    filterMenuTitleStyle() {
      return this.filterMenuLabel === DEFAULT_LABEL
        ? 'filter-menu-title'
        : 'filter-menu-title--selected';
    },
    filterMenuIcon() {
      return this.filterMenuLabel === DEFAULT_LABEL ? '' : 'arrow_drop_down';
    },
    filterMenuIconStyle() {
      return this.filterMenuLabel === DEFAULT_LABEL
        ? ['filter-menu-title', 'd-none']
        : ['filter-menu-title--selected'];
    },
  },
};
</script>

<style lang="scss" scoped>
.no-results-msg {
  text-align: center;
  color: var(--v-secondary-lighten2);
}
.filter-menu-title {
  color: var(--v-background-lighten5);
  &--selected {
    color: var(--v-primary-base);
  }
}
.filter-menu-default {
  background-color: var(--v-primary-base);
}
.filter-menu-applied {
  background-color: none;
  border: 0.05rem solid var(--v-primary-base);
}
.filter-menu-list {
  width: 300px;
}
.filter-list-container {
  max-height: 400px;
  overflow-y: auto;
}
.filter-menu-item {
  padding: 0;
}
.filter-types-everyone {
  font-size: 18px;
}
.filter-types-titles {
  font-size: 18px;
  border-top: 1px solid var(--v-background-lighten3);
}
.filter-search-field {
  border: 1px solid var(--v-primary-base);
}
.filter-search-label {
  font-size: 1.1rem;
  letter-spacing: -0.5px;
}
.filter-search-caption {
  margin-top: 8px;
  font-size: 13px;
  line-height: 14px;
  letter-spacing: 0.5px;
  color: var(--v-text-lighten1);
}
.filter-item-checkbox {
  transform: scale(1.8);
}
.filter-item-text {
  display: inline-block;
}
.warning-selections {
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  &--msg {
    text-align: center;
    font-size: 13px;
    width: 200px;
  }
}
.uncheck-selections {
  color: var(--v-primary-base);
  font-size: 14px;
}
.apply-btn-container {
  height: 70px;
  border-top: 1px solid var(--v-background-lighten3);
}
.apply-btn {
  font-size: 18px;
  padding: 0 30px;
}
</style>
